import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Stack } from '@mui/material'
import { useSetAtom } from 'jotai'
import { searchCondAtom, searchTriggerAtom } from 'store/commonAtoms'
import { H1 } from 'components/styledFonts'
import TwoColumns from 'components/TwoColumns'
import SearchConditions from './SearchConditions'
import {useSearchUrl} from 'hooks/search'


const SearchBase = () => {
    const { pathname } = useLocation()
    const setCond = useSetAtom(searchCondAtom)
    const setTrigger = useSetAtom(searchTriggerAtom)
    const { cond } = useSearchUrl()

    useEffect(() => {
        setCond(cond)
        setTrigger(true)

        window.scrollTo({
            top : 0,
            behavior : 'smooth',
        })
    }, [pathname, cond, setCond, setTrigger])


    return (
        <Stack
            gap={2}
        >
            <H1>情報検索</H1>
            <TwoColumns
                ratio="8fr 4fr"
            >
                <Outlet />
                <SearchConditions />
            </TwoColumns>
        </Stack>
    )
}

export default SearchBase
